/**
 * Tiny reducers shared by the lap-analysis modules. Kept private to lib/ —
 * the underscore prefix marks "do not import from outside this directory."
 */
import type { FirehoseSampleEntry } from "@contract/types";

/** Best-effort time-window predicate match: a sample falls in a lap if its startDate is inside. */
export function samplesInLap(
  samples: FirehoseSampleEntry[],
  startMs: number,
  endMs: number,
): FirehoseSampleEntry[] {
  return samples.filter((s) => {
    const t = new Date(s.startDate).getTime();
    return t >= startMs && t < endMs;
  });
}

export function averageOf(samples: FirehoseSampleEntry[]): number | null {
  const nums = samples.map((s) => s.value).filter((v): v is number => v !== null && v !== undefined);
  if (nums.length === 0) return null;
  return nums.reduce((a, b) => a + b, 0) / nums.length;
}

export function maxOf(samples: FirehoseSampleEntry[]): number | null {
  const nums = samples.map((s) => s.value).filter((v): v is number => v !== null && v !== undefined);
  if (nums.length === 0) return null;
  return Math.max(...nums);
}

export function peakSampleOf(samples: FirehoseSampleEntry[]): FirehoseSampleEntry | null {
  let peak: FirehoseSampleEntry | null = null;
  for (const s of samples) {
    if (s.value !== null && s.value !== undefined) {
      if (peak === null || s.value > (peak.value ?? -Infinity)) {
        peak = s;
      }
    }
  }
  return peak;
}

export function sumOf(samples: FirehoseSampleEntry[]): number {
  return samples
    .map((s) => s.value ?? 0)
    .reduce((a, b) => a + b, 0);
}
